<button (click)="handleClick()" class="secondary-btn {{className}}">
  {{text}}
</button>
